<template>
  <div>
    <template v-if="$is_mobile_view">
      <div class="d-flex price-decoy align-items-center justify-content-between position-relative" @click="goToLogin">
        <div class="d-flex align-items-center pr-4-5 border-r-form-dashed-2">
          <svg class="mr-2-5" height="22" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2207_8470)">
              <path
                d="M13.8655 26.2368L25.2912 14.7876C26.1701 13.9087 26.2287 13.4048 26.2287 12.1743V7.72119C26.2287 6.479 25.9358 6.09228 25.0451 5.20166L22.3498 2.50635C21.4709 1.62744 21.0842 1.32275 19.842 1.32275H15.3772C14.1467 1.32275 13.6545 1.38135 12.7756 2.26025L1.31471 13.6977C-0.361069 15.3735 -0.396226 17.1079 1.32643 18.8188L8.7444 26.2251C10.467 27.936 12.1897 27.9126 13.8655 26.2368ZM17.8733 10.6977C16.9475 10.6977 16.2678 9.98291 16.2678 9.09228C16.2678 8.18994 16.9475 7.48682 17.8733 7.48682C18.7873 7.48682 19.4787 8.18994 19.4787 9.09228C19.4787 9.98291 18.7873 10.6977 17.8733 10.6977Z"
                class="fill-primary" /> 
            </g>
            <defs>
              <clipPath id="clip0_2207_8470">
                <rect width="26.1826" height="27.3604" fill="white" transform="translate(0.0461426 0.140625)" />
              </clipPath>
            </defs>
          </svg>
          <div>
            <p class="mb-1 font-lato text-10 lh-1 w-100 text-center">Exclusive Member Price</p>
            <p class="mb-0 font-lato text-18 lh-1 text-green">{{ $formatCurrency($printRoomMemberPrice(roomRate.dates)) }}</p>
          </div>
        </div>
        <div>
          <p class="mb-1 font-lato text-12 lh-1 w-100 text-subcolor text-center">Save more</p>
          <p class="mb-0 font-lato text-12 lh-1 w-100 text-center">Just log in</p>
        </div>

        <div v-if="isLoading" class="w-100 position-absolute h-100 d-flex align-items-center justify-content-center rounded" style="background-color: rgba(255, 255, 255, 0.5);top: 0;left:0;">
          <div class="spinner-border spinner-border-sm" role="status" >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <p class="mb-0 mt-2 w-100 text-center body-3 text-danger" v-if="$isNotEmptyV2(errorMessage)">{{ errorMessage }}</p>
    </template>
    <template v-else>
      <div 
        :id="`price-decoy-${roomRate.id}`" 
        class="d-table ml-auto price-decoy position-relative" 
        :class="$isEmpty(errorMessage) ? 'mb-2' : 'mb-1'"
        @click="goToLogin">
        <p class="mb-0 font-lato text-12 lh-1 w-100 text-center">Exclusive Member Price</p>
        <div class="d-flex align-items-center justify-content-center mt-1 mb-1">
          <svg class="mr-2" height="18" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2207_8470)">
              <path
                d="M13.8655 26.2368L25.2912 14.7876C26.1701 13.9087 26.2287 13.4048 26.2287 12.1743V7.72119C26.2287 6.479 25.9358 6.09228 25.0451 5.20166L22.3498 2.50635C21.4709 1.62744 21.0842 1.32275 19.842 1.32275H15.3772C14.1467 1.32275 13.6545 1.38135 12.7756 2.26025L1.31471 13.6977C-0.361069 15.3735 -0.396226 17.1079 1.32643 18.8188L8.7444 26.2251C10.467 27.936 12.1897 27.9126 13.8655 26.2368ZM17.8733 10.6977C16.9475 10.6977 16.2678 9.98291 16.2678 9.09228C16.2678 8.18994 16.9475 7.48682 17.8733 7.48682C18.7873 7.48682 19.4787 8.18994 19.4787 9.09228C19.4787 9.98291 18.7873 10.6977 17.8733 10.6977Z"
                class="fill-primary" />
            </g>
            <defs>
              <clipPath id="clip0_2207_8470">
                <rect width="26.1826" height="27.3604" fill="white" transform="translate(0.0461426 0.140625)" />
              </clipPath>
            </defs>
          </svg>
          <p class="mb-0 font-lato text-22 lh-1 text-green">{{ $formatCurrency($printRoomMemberPrice(roomRate.dates)) }}</p>
        </div>
        <p class="mb-0 font-lato-regular text-12 lh-1 w-100 text-center text-subcolor">Save more - just log in</p>

        <div v-if="isLoading" class="w-100 position-absolute h-100 d-flex align-items-center justify-content-center rounded" style="background-color: rgba(255, 255, 255, 0.3);top: 0;left:0;">
          <div class="spinner-border spinner-border-sm" role="status" >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <p class="mb-2 w-100 text-right body-3 text-danger" v-if="$isNotEmptyV2(errorMessage)">{{ errorMessage }}</p>

      <b-tooltip v-if="useTooltip" :target="`price-decoy-${roomRate.id}`" placement="left">
        <p class="mb-0 body-2-4 text-white p-1">This special rate is available when you log in or register.</p>
      </b-tooltip>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'RoomPriceDecoy',
    props: {
      roomRate: {
        type: Object,
        default: () => ({})
      },
      useTooltip:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        isLoading: false,
        errorMessage: '',
        
      }
    },
    computed:{
      ...mapGetters(['getMerchant'])
    },
    watch:{
      errorMessage() {
        if(this.$isNotEmptyV2(this.errorMessage)){
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      }
    },
    methods:{
      goToLogin(){
        const { community, code } = this.getMerchant;
        
        if(this.$isEmpty(community)) {
          this.goToLoginMerchant(code);
          return;
        }

        const { use_group_booking_auth = false } = community;

        if(use_group_booking_auth) this.goToLoginCommunity();
        else this.goToLoginMerchant(code);
      },
      goToLoginMerchant(merchantCode){
        this.$router.push({
          path: `/${merchantCode}/login`, query: { next_page: 'BERoom' }
        })
      },
      async goToLoginCommunity(){
        if(this.isLoading) return;
        this.isLoading = true
        this.errorMessage = ''

        try {
          await this.$loginWithCommunity();
        } catch (error) {
          this.errorMessage = error.message || 'Login failed'
        } finally { 
          this.isLoading = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/RoomPriceDecoy.vue